<fgb-banner [pageName]="'home.page.title'" [isHomePage]="true" />

<ng-container *ifScreenSize="screenSize.Mobile">
  <div class="container bg-black">
    <fgb-mobile-nav-menu />

    <fgb-barcode [showSeating]="true" [showWalletButton]="true" />

    <div
      class="scroll-header-container container bg-black"
      [ngClass]="{ 'display-header': showTopMenu }"
    >
      <h4
        class="name-title mb-0 text-white text-uppercase"
        *ngIf="memberDetails$ | async as memberDetails"
      >
        {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
      </h4>
      <div class="ms-auto d-flex align-items-center widget-details gap-3">
        <button
          class="qrcode-btn text-white bg-glass-dark"
          (click)="navigateToWallet()"
        >
          <span class="icon material-icons material-mobile-nav text-white"
            >qr_code_2</span
          >
        </button>
      </div>
    </div>
  </div>
</ng-container>

<div class="home-page-padding">
  <div class="container home-inner-container">
    <!-- Quick Action Widgets -->
    <div class="d-flex gap-widget d-lg-none">
      <a
        class="home-widget-btn flex-grow-1 text-decoration-none"
        [href]="'nav.manage.tickets.url' | translate"
        target="_blank"
      >
        <span class="material-symbols-outlined" aria-hidden="true"
          >server_person</span
        >
        <span class="home-widget-label">{{
          "nav.manage.tickets" | translate
        }}</span>
      </a>
      <a
        class="home-widget-btn flex-grow-1 text-decoration-none"
        [href]="'nav.scan.parking.url' | translate"
        target="_blank"
      >
        <span class="material-symbols-outlined" aria-hidden="true"
          >local_parking</span
        >
        <span class="home-widget-label">{{
          "nav.scan.parking" | translate
        }}</span>
      </a>
    </div>

    <!-- How It Works Widget -->
    <fgb-how-it-works></fgb-how-it-works>

    <!-- DSN Link iframe -->
    <iframe
      [src]="dsnIframeUrl"
      class="dsn-iframe"
      frameborder="0"
      allowfullscreen
    ></iframe>
  </div>

  <!-- CM Offers -->
  <fgb-campaigns-v2-offers-list
    [showAllOffers]="true"
    [class.d-none]="!hasOffers"
    (dataChange)="onOffersData($event)"
  ></fgb-campaigns-v2-offers-list>

  <div class="container">
    <!-- Announcements -->
    <fgbcl-announcements></fgbcl-announcements>
  </div>
</div>
